/* eslint-disable array-callback-return */
import React, { Component, Fragment } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import axios from 'axios';

import { ToastContainer, toast } from 'react-toastify'; //토스트(toast)
import { confirmAlert } from 'react-confirm-alert'; //알럿창(alert confirm)
// import InfiniteScroll from "react-infinite-scroll-component";
import CustomerNoticeItemNew from '../../components/customer/CustomerNoticeItemNew';
import { isMobile, isAndroid, isIOS } from 'react-device-detect';

class MyReviewNew extends Component {
  state = {
    gotoPage: 1,
    pageCount: 1,
    pageSize: 20,
    dataList: [],
  };
  _isMounted = false;
  componentDidMount = () => {
    this._isMounted = true;
    this._getData(1);
  };
  componentWillUnmount = () => {
    this._isMounted = false;
  };

  _getData = async (gotoPage) => {
    const { loginId, pkg } = this.props;

    if (
      loginId === null ||
      loginId === undefined ||
      loginId === '' ||
      pkg === null ||
      pkg === undefined ||
      pkg === ''
    ) {
    } else {
      const result = await this._getDataApi(gotoPage);
      if (result) {
        const intReturn = result.data[0].intReturn;
        const pageCount = result.data[0].pageCount;
        const con = result.data[0].con;
        const dataList = result.data[0].listData;
        //console.log(con)
        if (this._isMounted) {
          if (intReturn === 0) {
            if (con > 0) {
              //console.log('con > 0')
              this.setState({
                gotoPage: gotoPage,
                con: con,
                pageCount: pageCount,
                dataList: dataList,
                hasMore: pageCount < gotoPage ? false : true,
              });
            } else {
              //console.log('con < 0')
              this.setState({
                gotoPage: 1,
                con: con,
                dataList: [],
                hasMore: pageCount < gotoPage ? false : true,
              });
            }
          } else {
            //console.log('intReturn <> 0')
            this.setState({
              gotoPage: 1,
              con: con,
              dataList: [],
              hasMore: pageCount < gotoPage ? false : true,
            });
          }
        }
      }
    }
  };
  getCookie = (name) => {
    var value = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');

    return value ? value[2] : null;
  };
  _getDataApi = (gotoPage) => {
    const { apiUrl, loginId, authId, pkg, history } = this.props;
    const at = this.getCookie('at');

    // const at = localStorage.getItem('at');

    return axios
      .post(
        apiUrl + '/myReview_pkg',
        {
          params: {
            userid: loginId,
            authId: authId,
            gotoPage: gotoPage,
            pkg: pkg,
          },
        },
        {
          headers: {
            Authorization: 'bearer ' + at,
          },
        }
      )
      .then((response) => response)
      .catch((error) => {
        //alert('오류가 발생했습니다.')
        if (error.response.status === 403) {
          //console.log('refresh....token...')
          this._refreshToken(0);
        } else if (error.response.status === 400) {
          history.push('/login');
        }
      });
  };
  _refreshToken = async (part) => {
    const { gotoPage } = this.state;
    const { history, apiUrl, setLoginId, setAuthId, loginId } = this.props;
    // const rt = localStorage.getItem('rt');
    const rt = this.getCookie('rt');
    if (rt === '' || rt === undefined || rt === null) {
      history.push('/login');
      return false;
    }

    const { data } = await axios.post(apiUrl + '/refreshToken', {
      params: {
        rt: rt,
        userid: loginId,
      },
    });

    if (data[0].intReturn === 0) {
      //console.log(data[0].at)
      localStorage.setItem('at', data[0].at);
      if (part === 0) {
        this._getData(gotoPage);
      } else {
        this._onDelete(part);
      }
    } else {
      this.setCookie('account', '');

      setLoginId('');
      setAuthId('');

      setTimeout(() => {
        history.push('/login');
      }, 500);
    }
  };
  setCookie = (name, value, exp) => {
    let expires;
    if (exp) {
      var date = new Date();
      date.setTime(date.getTime() + exp * 24 * 60 * 60 * 1000);
      expires = date.toGMTString();
    } else {
      expires = '';
    }
    document.cookie =
      name +
      '=' +
      value +
      ';expires=' +
      expires +
      ';path=/; SameSite=None; Secure; domain=aniplustv.com';
  };
  _renderItem = () => {
    const { dataList } = this.state;
    const list = dataList.map((item, index) => {
      return (
        <CustomerNoticeItemNew
          key={index}
          index={index}
          idx={item.idx}
          //refo = {item.refo}
          //step = {item.step}
          //re_level = {item.re_level}
          userid={item.userid}
          nicName={item.nicName}
          //board_id = {item.board_id}
          title={item.title}
          writeDay={item.regDate}
          //charac_img = {item.charac_img}
          //categoryID = {item.categoryID}
          //categoryName = {item.categoryName}
          content={item.content}
          //replay_idx={item.replay_idx}
          //onItemDel = {this._onItemDel}
          //numm={item.numm}
          //chkNotice={item.chkNotice}
          selected={item.selected}
          _selected={this._selected}
        />
        /*
                <ul key={index}>
                    <li className="date">{item.regDate}</li>
                    <li className="info">
                        <p className="subject">{item.title}</p>
                        <div className="con">
                        {item.content}
                        </div>
                    </li>
                    <input type="checkbox" className="chkBox" name="chk" id="chk1"/><label for="chk1" className="chk"></label>
                </ul>
                
                <tr key={index}> 
                    <td>{item.regDate}</td>
                    <td><span onClick={()=>this._goItem(item.contentSerial)} style={{cursor: 'pointer'}}>{item.title}</span></td>
                    <td><div className="text_line">{item.content}</div></td>
                    <td><img style={{cursor: 'pointer'}} onClick={()=>this._onDelete(item.idx)} src="/img/mypage/del2.png"/></td>
                </tr>
                */
      );
    });

    return list;
  };
  _goItem = (contentSerial) => {
    const { setContentSerial } = this.props;

    setContentSerial(contentSerial);
  };
  _onDelete = async (idx) => {
    const result = await this._onDeleteApi(idx);
    if (result) {
      const intReturn = result.data[0].intReturn;

      //console.log(intReturn)
      if (intReturn === 0) {
        toast.success('작성된 리뷰가 삭제 되었습니다.');
        this._getData(1);
      } else {
        toast.warn('삭제할 리뷰가 존재하지 안습니다.');
      }
    }
  };
  _onDeleteApi = (idx) => {
    const { apiUrl, loginId, authId, history } = this.props;
    const at = this.getCookie('at');
    // const at = localStorage.getItem('at');

    return axios
      .post(
        apiUrl + '/myReviewDel',
        {
          params: {
            userid: loginId,
            authId,
            idx: idx,
          },
        },
        {
          headers: {
            Authorization: 'bearer ' + at,
          },
        }
      )
      .then((response) => response)
      .catch((error) => {
        //alert('오류가 발생했습니다.')
        if (error.response.status === 403) {
          //console.log('refresh....token...')
          this._refreshToken(idx);
        } else if (error.response.status === 400) {
          history.push('/login');
        }
      });
  };

  _onAllDelete = () => {
    const { dataList } = this.state;
    if (dataList.length <= 0) {
      toast.warn('삭제할 리뷰가 존재하지 안습니다.');
      return;
    }

    confirmAlert({
      title: '리뷰 전체 삭제',
      message:
        '작성하신 모든 리뷰를 삭제하시겠습니까? 삭제된 데이터는 복구 되지 않습니다.',
      buttons: [
        {
          label: '모두 삭제',
          onClick: async () => {
            const result = await this._onAllDeleteApi();
            const intReturn = result.data[0].intReturn;

            if (intReturn === 0) {
              toast.success('작성된 리뷰가 모두 삭제 되었습니다.');
              this._getData(1);
            } else {
              toast.warn('삭제할 리뷰가 존재하지 안습니다.');
            }
          },
        },

        {
          label: '취소',
          //onClick: () => alert('Click No')
        },
      ],
    });
  };
  _onAllDeleteApi = () => {
    const { apiUrl, loginId, authId } = this.props;

    return axios
      .post(apiUrl + '/myReviewAllDel', {
        params: {
          userid: loginId,
          authId: authId,
        },
      })
      .then((response) => response)
      .catch((error) => {
        // alert("오류가 발생했습니다.");
      });
  };
  _renderPage = () => {
    const { gotoPage, con, pageCount } = this.state;

    const dataPerPage = isMobile ? 5 : 10; //한페이지에 보여질 갯수
    let pageCount1;

    if (pageCount > dataPerPage) {
      pageCount1 = dataPerPage;
    } else {
      pageCount1 = pageCount;
    }
    const pageNumbers = [];

    const totalPage = Math.ceil(con / dataPerPage); //총페이지수
    const pageGroup = Math.ceil(gotoPage / pageCount1); //페이지 그룹
    let last = pageGroup * pageCount1;

    if (last > totalPage) {
      last = totalPage;
    }

    let first = last - (pageCount1 - 1); //화면에 보여질 첫번째 페이지 번호

    const next = last + 1;
    // const prev = first - 1;

    if (totalPage < 1) {
      first = last;
    }

    if (first > pageCount1) {
    } else {
    }

    if (next > pageCount1 && next < totalPage) {
    } else {
    }

    for (let j = first; j <= last; j++) {
      pageNumbers.push(j);
    }

    const list = pageNumbers.map((num, index) => {
      return (
        <span
          key={index}
          style={{ cursor: 'pointer' }}
          onClick={() => this._getData(num)}
          className={gotoPage === num ? 'on' : null}
        >
          {num}
        </span>
        /*<a href="#" className={gotoPage === num ? "active" : null } onClick={()=>this._page(num)} key={index}>{num}</a>*/
      );
    });

    return (
      <Fragment>
        {first > pageCount1 ? (
          <span onClick={this._onPrev}>이전</span>
        ) : (
          <span style={{ backgroundColor: '#000' }}></span>
        )}
        {list}
        {next > pageCount1 && next < totalPage ? (
          <span onClick={this._onNext}>다음</span>
        ) : (
          <span style={{ backgroundColor: '#000' }}></span>
        )}
      </Fragment>
    );
  };

  _onPrev = () => {
    const { gotoPage } = this.state;

    if (gotoPage === 1) {
      //alert('페이지의 처음입니다.')
      toast.warn('페이지의 처음입니다.');
    } else {
      this._getData(gotoPage - 1);
    }
  };
  _onNext = () => {
    const { gotoPage, pageCount } = this.state;
    if (gotoPage + 1 >= pageCount) {
      toast.warn('페이지의 마지막입니다.');
      //alert('페이지의 마지막입니다.')
    } else {
      this._getData(gotoPage + 1);
    }
  };
  _allSelect = () => {
    const { allSelect, dataList } = this.state;

    dataList.map((item, index) => {
      if (!allSelect) {
        item.selected = item.idx;
      } else {
        item.selected = 0;
      }
    });

    this.setState({
      allSelect: !allSelect,
    });
  };

  _selected = (index, idx) => {
    const { dataList } = this.state;

    if (dataList[index].selected === 0) {
      dataList[index].selected = idx;
    } else {
      dataList[index].selected = 0;
    }

    this.setState({
      dataList,
    });
  };
  _alertDel = () => {
    // const { loginId } = this.props;
    const { dataList } = this.state;

    let delList = [];
    dataList.find((item, index) => {
      if (item.selected !== 0) {
        delList.push(item.idx);
      }
    });

    if (delList.length <= 0) {
      toast.warn('삭제할 글이 존재하지 않습니다.');
    } else {
      let stringCode = '';
      delList.map((item, index) => {
        stringCode = stringCode + item + '|';
      });

      confirmAlert({
        title: '선택글 삭제',
        message:
          '선택하신 글을 모두 삭제하시겠습니까? 삭제된 글은 복구되지 않습니다.',
        buttons: [
          {
            label: '삭제',
            onClick: () => {
              this._del(stringCode);
            },
          },

          {
            label: '취소',
            //onClick: () => alert('Click No')
          },
        ],
      });
    }
  };
  _del = async (stringCode) => {
    const result = await this._delApi(stringCode);
    const intReturn = result.data[0].intReturn;

    if (intReturn === 0) {
      this.getData(1);
    }
  };

  _delApi = (stringCode) => {
    const { apiUrl, loginId } = this.props;

    return axios
      .post(apiUrl + '/myReviewSelectDel', {
        params: {
          userid: loginId,
          stringCode: stringCode,
        },
      })
      .then((response) => response)
      .catch((error) => {
        //console.log('error..')
      });
  };

  render() {
    // const { tabIndex } = this.props.childProps;
    const { dataList, con, allSelect } = this.state;
    return (
      <Fragment>
        <div className="list_wrap">
          <div className="listHead">
            <span className="total">
              총 <em>{con}</em>개
            </span>
            <div className="fl_rt">
              <button type="button" className="btn_del">
                선택삭제
              </button>
              <input
                type="checkbox"
                className="chkBox"
                name="chk"
                id="chkAll"
                checked={allSelect}
                onChange={this._allSelect}
              />
              <label htmlFor="chkAll" className="chk"></label>
            </div>
          </div>
          <div className="list wrote">
            {dataList ? this._renderItem() : null}
          </div>
          <div className="page_no">{dataList ? this._renderPage() : null}</div>
        </div>
        <ToastContainer position="bottom-right" hideProgressBar />
      </Fragment>
    );
  }
}

export default shopContext(withRouter(MyReviewNew));
